import { formatPricingFromMinAndMax } from '@sly/core/helpers/numbers';
import React from 'react';

const PartnerPricingTable = ({ priceRangeTOC, className }) => {
  return (
    <div
      className={className}
      data-tp-id='gen-div-90f7d539-04c7-4614-adce-3534559eade0'
    >
      <div
        className='pt-0 pb-m'
        itemScope
        itemType='http://schema.org/Table'
        data-tp-id='gen-div-ccad1ceb-aa97-46a4-9762-f8e1de5666ad'
      >
        <table className='font-b-m relative table w-full table-fixed border-separate border-spacing-0 rounded border border-slate-lighter-90'>
          <thead className='table-header-group'>
            <tr className='table-row'>
              <th
                className='font-t-xs-azo bg-slate-lighter-95 py-m pl-l pr-0 text-left'
                itemProp='type-of-care'
              >
                Type of care
              </th>
              <th
                className='font-t-xs-azo bg-slate-lighter-95 py-m pl-m text-left'
                itemProp='estimated-price'
              >
                Estimated monthly prices
              </th>
            </tr>
          </thead>
          <tbody className='table-row-group'>
            {Object.entries(priceRangeTOC).map(([name, price]) => (
              <>
                {(!!price?.max || !!price?.min) && (
                  <tr className='table-row' key={name}>
                    <td className='table-cell py-m pl-l pr-0'>{name}</td>

                    <td className='table-cell py-m pl-m'>
                      <span data-tp-id='gen-span-8ec4b36a-84f2-477f-aea4-e737cc4a4581'>
                        {formatPricingFromMinAndMax(price.min, price.max)}
                      </span>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PartnerPricingTable;
